import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";

import { GENERIC_UPLOAD_FORM_FIELDS, Log } from "@ryde/shared";

export const useGenericUploadForm = () => {
  const { watch, setValue } = useFormContext();

  const file: File | undefined = watch(GENERIC_UPLOAD_FORM_FIELDS.file);

  const onFileChange = useEvent((newFile: File) => {
    Log.debug("onFileChange event, file:", newFile);
    setValue(GENERIC_UPLOAD_FORM_FIELDS.file, newFile);
  });

  const onFileClear = useEvent(() => {
    Log.debug("onFileClear event");
    setValue(GENERIC_UPLOAD_FORM_FIELDS.file, undefined);
  });

  return {
    file,
    onFileChange,
    onFileClear,
  };
};
